export const DISABLED_ASSET_TOOLTIP_TEXT =
  'Asset(s) cannot be added to the current Order type.';
export const DISABLED_PRODUCT_TOOLTIP_TEXT =
  'Product(s) cannot be added to the current Order type.';
